import { render, staticRenderFns } from "./CreateTermicCourse.vue?vue&type=template&id=ffef59e8&scoped=true"
import script from "./CreateTermicCourse.vue?vue&type=script&lang=js"
export * from "./CreateTermicCourse.vue?vue&type=script&lang=js"
import style0 from "./CreateTermicCourse.vue?vue&type=style&index=0&id=ffef59e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffef59e8",
  null
  
)

export default component.exports